import React, { useLayoutEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";

// The sidebar sets its own width (264px, or 76px when collapsed). The page
// offset used to be a fixed 13% of the viewport, which is narrower than the
// sidebar on most screens (content slid underneath it) and far wider than the
// collapsed sidebar (a big empty gap). Follow the sidebar's real width instead.
const DEFAULT_SIDEBAR_WIDTH = 264;

const Layout = ({ children, pageTitle }) => {
  const asideRef = useRef(null);
  const [sidebarWidth, setSidebarWidth] = useState(DEFAULT_SIDEBAR_WIDTH);

  useLayoutEffect(() => {
    const el = asideRef.current;
    if (!el) return undefined;
    const measure = () => setSidebarWidth(el.offsetWidth || DEFAULT_SIDEBAR_WIDTH);
    measure();
    if (typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <header className="w-full bg-white fixed">
        <Header pageTitle={pageTitle} />
      </header>
      <div className="flex">
        <aside ref={asideRef} className="h-screen fixed top-0 left-0 z-50">
          <Sidebar />
        </aside>
        <div className="flex-1 min-w-0 overflow-x-hidden" style={{ marginLeft: sidebarWidth }}>
          {children !== undefined ? children : <Outlet />}
        </div>
      </div>
    </div>
  );
};

export default Layout;
